import { PaymentProcessError } from '@b2b/common/directives/payment/types';
import { NoticeFactory } from '@b2b/common/factories/notice';
import { ACMETenantResponse, TenantData, ThemesData } from '@b2b/common/resolvers';
import { CartService, CartServiceModule } from '@b2b/common/services';
import { AddressService, AddressServiceModule } from '@b2b/common/services/address';
import { LocationService, LocationServiceModule } from '@b2b/common/services/address/location.service';
import { ApiService } from '@b2b/common/services/api/types';
import { CheckoutData, SecureCheckoutProps } from '@b2b/common/services/checkout/checkout.types';
import {
  CheckoutProcessService,
  CheckoutProcessServiceModule,
} from '@b2b/common/services/checkout/checkoutProcess.service';
import { isACMECORSCheckoutError } from '@b2b/common/services/checkout/types';
import { FeatureService, FeatureServiceModule } from '@b2b/common/services/feature/feature.service';
import { PermissionsService } from '@b2b/common/services/permissions';
import { VCardModalControllerModule } from '@b2b/common/views/modals/vcard/controllers/VcardModalController';
import { CartOrderForm, createAutorenewInCart } from '@b2b/types/cart';
import { ACMEResponse, LooseAutocomplete, TODO, UIBModalService } from '@b2b/types/core';
import { Membership, MembershipCardholder, MembershipLevelOffering } from '@b2b/types/membership';
import { Organization } from '@b2b/types/organization';
import { PaymentMethod } from '@b2b/types/payment';
import uiRouter, { StateService } from '@uirouter/angularjs';
import angular, { IFilterService, IQService, IRootScopeService, ISCEService, IScope, ITimeoutService } from 'angular';
import _ from 'lodash';
import { CartOrderConfirmationEmailComponentModule } from '../components/cart-order-confirmation-email/cart-order-confirmation-email.component';
import { CartFormsService, CartFormsServiceModule } from '../components/cart-forms/services/cart-forms.service';

CartController.$inject = [
  '$rootScope',
  '$scope',
  '$state',
  '$timeout',
  '$filter',
  '$q',
  '$sce',
  '$uibModal',
  'CartService',
  'CalendarService',
  'AuthService',
  'ApiService',
  'ValidateService',
  'HelpersService',
  'NoticeFactory',
  'uuid2',
  'MembershipService',
  'AddressService',
  'ThemesHelperService',
  'OrderService',
  'FeatureService',
  'PermissionsService',
  'ThemesData',
  'GridStateFactory',
  'uibDropdownConfig',
  'CheckoutProcessService',
  'LocationService',
  'TenantData',
  'CartFormsService',
];

function CartController(
  $rootScope: IRootScopeService,
  $scope: IScope & { cart: TODO; noticeTimer: TODO },
  $state: StateService,
  $timeout: ITimeoutService,
  $filter: IFilterService,
  $q: IQService,
  $sce: ISCEService,
  $uibModal: UIBModalService,
  CartService: CartService,
  CalendarService: TODO,
  AuthService: TODO,
  ApiService: ApiService,
  ValidateService: TODO,
  HelpersService: TODO,
  NoticeFactory: NoticeFactory,
  uuid2: TODO,
  MembershipService: TODO,
  addressService: AddressService,
  ThemesHelperService: TODO,
  OrderService: TODO,
  FeatureService: FeatureService,
  PermissionsService: PermissionsService,
  ThemesData: { data: ACMEResponse<ThemesData> },
  GridStateFactory: TODO,
  uibDropdownConfig: TODO,
  CheckoutProcessService: CheckoutProcessService,
  LocationService: LocationService,
  TenantData: { data: ACMETenantResponse<TenantData> },
  cartFormsService: CartFormsService,
) {
  const ctrl = {
    vm: {
      sections: {
        membershipCardsEmail: { show: false },
      },
      primaryCardholder: undefined,
    },

    isSubmitted: false,
    isPaymentProcessing: false,
    requestUUID: false as string | false,
    total: 0,
    hasEmailError: false,
    accountId: undefined as number | undefined,
    notes: '',
    reservation: undefined as { id: string } | undefined,
    noEmail: false,
    sendEmailToAll: false,
    validateEmail: false,
    organization: null as Partial<Organization> | null,

    model: null as TODO | null,
    summary: null as TODO | null,

    tenant: {} as TenantData,

    memberships: [] as TODO[],
    membershipLevels: [] as TODO[],
    autorenewInCart: createAutorenewInCart(),

    events: [] as TODO[],

    forms: [] as CartOrderForm[],

    errors: {} as Partial<Record<'membershipErrors' | 'paymentErrors' | 'ticketErrors' | 'reservationErrors' | 'formErrors', any>>,

    payment: { type: '' } as { type?: LooseAutocomplete<PaymentMethod> },

    user: AuthService.getCookie('user'),

    isAccount: false,
    selectedAccountContact: false as TODO | false,
    orderContact: null as TODO | null,

    emailOption: false as number | false,

    notice: new NoticeFactory(),

    cartService: CartService,

    languagesGridState: new GridStateFactory(),
    languagesList: [],
    customerDuplicatesState: [] as TODO[],

    customerMembershipsState: [] as TODO[],
    loadingCustomerMemberships: false,

    termsURL: '',

    membershipErrors: {
      tooManyCards: {
        message: 'This membership only allows up to %s cardholders. Please adjust.',
      },
      missingPrimaryCard: {
        message: 'Memberships are required to have a primary cardholder.',
      },
      missingPrimaryCardAddress: {
        message: 'Address is required for this customer to be a primary cardholder.',
      },
      missingPrimaryCardEmailForAutorenew: {
        message: 'Required fields are missing for the primary cardholder.',
      },
    },
    paymentErrors: {
      creditCardPaymentRequiredForAutorenew: {
        message: 'Required: A credit card must be used to pay for an Auto Renew membership.',
      },
    },

    invoiceAfterEvent: false,
    ticketDelivery: 'print',
    emailLanguage: false,
    //we always hide ticket delivery for the cart page since design decoupled it from payment
    hideTicketDelivery: true,

    themes: {},
    showCustomers: false,

    CODES: {
      errors: {
        TICKET_LIMIT_EXCEEDED: 9049, // Ticket limit for at least one ticket type has been exceeded
      },
    },

    isEnabledCORSCheckout: false,
    corsCheckoutCreditCardMessage: `Payment will be securely collected when you select "Take Payment & Place Order"`,

    cancelSuccess: (response) => {
      ctrl.notice.hideSuccessMessages();
      ctrl.notice.hideErrorMessages();
      ctrl.refresh();
      CartService.memberships.clearCustomerData();
      CartService.send({ type: 'RESET' });
      cartFormsService.clearFormResponses();
    },

    cancelError: (response) => {
      ctrl.notice.showErrorMessages([{ message: response.data.error }]);
    },

    completeSuccess: (response: TODO) => {
      $scope.$emit('Cart::Close');
      ctrl.cartService.cancelCart().then(ctrl.cancelSuccess).catch(ctrl.cancelError);

      if ($state.params.accountId) {
        $state.go('application.orders.detail.summary', {
          accountId: $state.params.accountId,
          orderId: response.id,
        });
      } else {
        $state.go('application.orders.detail.summary', { orderId: response.id });
      }

      /**
       * State should have changed it is safe to restore on next tick
       *   requestUUID: false
       */
      // next tick
      $timeout(() => {
        ctrl.requestUUID = false;
      }, 0);
    },

    completeError: (response: { status: number; data: PaymentProcessError }) => {
      const responseData = response.data ?? { error: '', code: 0, errorCode: 0 };
      const responseDataError = responseData.error || '';

      /**
       * When error status is 409 it is a duplicate order
       * We must call to retrieve the actual order based on the UUID
       */
      if (response.status === 409 && responseData.errorCode === 20152) {
        ctrl.getDuplicateOrder();
      } else {
        ctrl.clearLoading();

        if (responseData.code === ctrl.CODES.errors.TICKET_LIMIT_EXCEEDED) {
          if (responseDataError) {
            ctrl.cartService.events.salesRulesSuccess(JSON.parse(responseDataError));

            $scope.$broadcast('Payment::Process::Error', { response: response });

            ctrl.notice.showErrorMessages([{ message: 'Ticket Limits exceeded.' }]);
          }
        } else {
          $scope.$broadcast('Payment::Process::Error', { response: response });

          const messages = response.data.errors
            ? response.data.errors.map((error) => ({ message: error.message.replace(/^.*?:/, '') }))
            : [{ message: response.data.error.replace(/^.*?:/, '') }];

          ctrl.notice.showErrorMessages(messages);

          /**
           * This is order duplication prevention
           * We create the checkout UUID and tack it onto the checkout request
           * Only rewrite the requestUUID when there are no errors and a checkout has taken place
           * This will always be refreshed when the page is refreshed, but, in the context of an order
           * we need to re-issue another uuid if a normal error happens
           */
          ctrl.requestUUID = uuid2.newuuid();
        }
      }
    },

    init: function () {
      uibDropdownConfig.appendToOpenClass = uibDropdownConfig.appendToOpenClass + ' cart-dropdown-body-open';

      $scope.$emit('Application::contentTitleChange', {
        title: 'Cart',
      });

      ctrl.cartService
        .getCart()
        .then((response) => {
          ctrl.initWatchers();
        })
        .catch((response) => {
          ctrl.initWatchers();
        });

      ThemesHelperService.resetModel();

      if (ThemesData && ThemesData.data.success) {
        ctrl.initThemes(ThemesData);
      }

      ctrl.showCustomers =
        FeatureService.isEnabled(FeatureService.customers) && PermissionsService.check('CUSTOMERS_VIEW');

      if (TenantData && TenantData.data.success) {
        ctrl.getTenant(TenantData.data.tenant);
      }
    },

    initWatchers: function () {
      $scope.$on('Payment::Complete', ctrl.onPaymentComplete);
      $scope.$on('Payment::Error', ctrl.onPaymentError);
      $scope.$on('OrderItem::Remove', ctrl.onOrderItemRemove);
      $scope.$on('OrderItem::Remove::Error', ctrl.onOrderItemRemoveError);
      $rootScope.$on('OrderItem::Remove', ctrl.onOrderItemRemove);
      $rootScope.$on('OrderItem::Remove::Error', ctrl.onOrderItemRemoveError);
      $scope.$on('Payment::showCardModal', ctrl.onPaymentShowCardModal);
      $scope.$on('Payment::Update::PaymentMethod', ctrl.onPaymentMethodUpdate);
      $scope.$on('OrderCoupons::Updating', function () {
        ctrl.startSubmitting();
      });
      $scope.$on('OrderCoupons::Updated', function () {
        ctrl.updateTotal();
        ctrl.stopSubmitting();
      });
      $scope.$on('$destroy', $scope.$watch('cart.cartService.itemCount', ctrl.onItemCountUpdated));
      $scope.$on('$destroy', $scope.$watch('cart.cartService.events.events.length', ctrl.onItemCountUpdated));
      $scope.$on('$destroy', $scope.$watch('cart.cartService.organization', ctrl.onCartOrganizationUpdate));
      $scope.$on('$destroy', $scope.$watch('cart.cartService.initted', ctrl.onCartServiceInitted));
      $scope.$on('OrderItem::Update', ctrl.onOrderItemUpdated);
      $scope.$on('$destroy', $scope.$watch('cart.invoiceAfterEvent', ctrl.onCheckedInvoiceAfterEvent));
      $scope.$on('$destroy', $scope.$watch('cart.emailOption', ctrl.onEmailOptionUpdate));
      $scope.$on('$destroy', $scope.$watchCollection('cart.memberships', ctrl.onMembershipsUpdate));

      ctrl.selectEmailOption();
    },

    initThemes: function (response) {
      ThemesHelperService.setModel(response.data.payload);
      CheckoutProcessService.initACMECheckout();

      ctrl.themes = {
        policyTerms: $sce.trustAsHtml(ThemesHelperService.getHTMLVariable('checkout-process-page-terms')),
      };

      ctrl.isEnabledCORSCheckout = CheckoutProcessService.isEnabledCORSCheckout();

      ctrl.initTenantLanguages();
    },

    initTenantLanguages: function () {
      ctrl.languagesGridState.setPropertyValue('sortField', 'name');

      // ApiService.administration.languages.list(ctrl.languagesGridState.getGridState()).then((res) => {
      // TODO: @see ENG-12405
      // This crashes because list doesn't exist and just retrieving the payload seems weird because we select
      // the first language in the list by default (i.e Afar)

      // ctrl.languagesList = res.data.payload.list.map(function(item) {
      //   item.id = item.code;
      //   return item;
      // });
      // ctrl.emailLanguage = ctrl.languagesList[0];
      // });
    },

    getTenant: function (tenantData: TenantData) {
      ctrl.tenant = tenantData;
      ctrl.termsURL = `${ctrl.tenant.consumerPage.replace(/events/gi, 'legal')}/terms`;
    },

    getThumbnail: function (level) {
      if (
        level &&
        level.images instanceof Array &&
        level.images.length &&
        level.images[0] &&
        level.images[0].thumbnail
      ) {
        return level.images[0].thumbnail;
      }

      return '/assets/img/global/no-image-landscape.png';
    },

    onOfferingChanged: function (props: { membership: TODO; pricepoint: TODO }, index: number) {
      const membership = props.membership;
      const selectedOffering = props.pricepoint;

      if (
        (membership.level.selectedOffering &&
          membership.membershipInfo.membershipOfferingId !== selectedOffering.offeringId) ||
        membership.membershipInfo.pricePointId !== selectedOffering.pricepointId
      ) {
        membership.membershipInfo.membershipOfferingId = selectedOffering.offeringId;
        membership.membershipInfo.pricePointId = selectedOffering.pricepointId;
        membership.amount = selectedOffering.amount;
        membership.unitPrice = selectedOffering.unitPrice;
        membership.retailUnitPrice = selectedOffering.retailUnitPrice;

        const foundOffering = ctrl.cartService.memberships.findSelectedOfferingFromMembershipLevels(
          ctrl.membershipLevels,
          membership,
        );
        ctrl.setMembershipInfoAutorenewFromOffering(foundOffering, membership);

        CartService.updateCart()
          .then(() => {
            ctrl.refresh();
          })
          .catch(() => {
            //do nothing
          });
      }
    },

    startSubmitting() {
      ctrl.isSubmitted = true;
      CartService.setStatus('loading');
    },

    stopSubmitting() {
      ctrl.isSubmitted = false;
      CartService.setStatus('idle');
    },

    refresh: function () {
      ctrl.startSubmitting();
      ctrl.model = ctrl.cartService.getModel();
      ctrl.summary = ctrl.cartService.getSummary();
      ctrl.memberships = ctrl.cartService.memberships.getModel();
      ctrl.events = ctrl.cartService.events.getEvents();

      // Get all forms (events + memberships)
      ctrl.cartService.getAllForms().then((forms) => {
        ctrl.forms = forms;
      });

      if (!ctrl.memberships.length) {
        ctrl.orderContact = ctrl.processOrderContact(ctrl.cartService.getOrderContact());
      } else {
        ctrl.orderContact = null;
      }
      ctrl.updateTotal();
      ctrl.checkCartValid();

      /**
       * We have to check if there are possible duplicates when coming back to the cart
       */
      const customerDuplicatesState = ctrl.getCustomerDuplicatesState();
      ctrl.customerDuplicatesState = customerDuplicatesState;

      if (ctrl.memberships.length) {
        if (customerDuplicatesState.length === 0) {
          ctrl.checkForDupes(ctrl.memberships[0].membershipInfo.membershipCards);
        }

        if (customerDuplicatesState.length > 0 && !ctrl.loadingCustomerMemberships) {
          ctrl.checkForSelectedCustomerMemberships(customerDuplicatesState);
        }
      }

      Promise.all(
        ctrl.memberships.map((membership) => {
          return CartService.memberships.fetchMembershipLevelDetail(membership).catch(() => null);
        }),
      )
        .then((responses) => {
          ctrl.membershipLevels = responses.filter((response) => response != null);
          if (ctrl.memberships.length) {
            ctrl.memberships.forEach((membership, index) => {
              const foundOffering = ctrl.cartService.memberships.findSelectedOfferingFromMembershipLevels(
                ctrl.membershipLevels,
                membership,
              );
              const autorenewalType = HelpersService.path(foundOffering, ['autorenewalType'], 'none');
              ctrl.setMembershipInfoAutorenewFromOffering(foundOffering, membership);

              if (index === 0) {
                ctrl.autorenewInCart = createAutorenewInCart({
                  autorenewalType: autorenewalType,
                  enabled: membership.membershipInfo.isAutorenew,
                });

                CartService.setAutorenewInCart(ctrl.autorenewInCart);
              }
            });
          } else {
            ctrl.autorenewInCart = createAutorenewInCart();
            CartService.setAutorenewInCart(ctrl.autorenewInCart);
          }
        })
        .finally(() => {
          ctrl.stopSubmitting();
          $scope.$apply();
        });
    },

    setMembershipInfoAutorenewFromOffering: function (offering: MembershipLevelOffering, membership: Membership) {
      const autorenewalType = HelpersService.path(offering, ['autorenewalType'], 'none');

      if (autorenewalType === 'none') {
        membership.membershipInfo.isAutorenew = false;
      } else if (autorenewalType === 'optional') {
        if (membership.membershipInfo.isAutorenew == null) {
          membership.membershipInfo.isAutorenew = false;
        }
      } else if (autorenewalType === 'required') {
        membership.membershipInfo.isAutorenew = true;
      }
    },

    processOrderContact: function (contact) {
      let customer;

      if (contact && contact.customerId && ctrl.memberships && ctrl.memberships.length) {
        angular.forEach(ctrl.memberships, function (membership) {
          customer = ctrl.cartService.memberships.getOrderContact(
            membership.membershipInfo.membershipCards,
            contact.customerId,
          );
          if (customer) {
            contact.cardType = customer.cardType;
          }
        });
      }

      return contact;
    },

    selectEmailOption: function () {
      if (ctrl.noEmail) {
        ctrl.emailOption = 0;
      } else if (ctrl.sendEmailToAll) {
        ctrl.emailOption = 2;
      } else if (!ctrl.noEmail && !ctrl.sendEmailToAll) {
        ctrl.emailOption = 1;
      }
    },

    setEmailOption: function () {
      switch (parseInt(ctrl.emailOption as TODO, 10)) {
        case 0:
          ctrl.noEmail = true;
          ctrl.sendEmailToAll = false;
          ctrl.ticketDelivery = 'willCall';
          break;
        case 1:
          ctrl.noEmail = false;
          ctrl.sendEmailToAll = false;
          break;
        case 2:
          ctrl.noEmail = false;
          ctrl.sendEmailToAll = true;
          break;
      }
    },

    getAddresses: function (membership) {
      addressService.reset(membership.membershipInfo.membershipId);
      if (membership && membership.membershipInfo.membershipCards instanceof Array) {
        angular.forEach(membership.membershipInfo.membershipCards, function (card) {
          if (addressService.checkAddress(card.address)) {
            addressService.add(membership.membershipInfo.membershipId, card.address, false);
          }
        });
      }
    },

    getPrimaryCardholder: function (membership) {
      let memberships: TODO[] = [];

      if (membership && membership.membershipInfo.membershipCards instanceof Array) {
        memberships = membership.membershipInfo.membershipCards.filter((cardholder) => {
          return cardholder.cardType === 'primary';
        });
      }

      return memberships.length ? memberships[0] : null;
    },

    isCardType: function (cardholder, type) {
      return cardholder && cardholder.cardType && cardholder.cardType === type;
    },

    updateMembershipCardTypes: function (cardholder, membership, index) {
      if (ctrl.isCardType(cardholder, 'primary')) {
        if (cardholder.id) {
          membership.membershipInfo.membershipCards.forEach((memberCard) => {
            if (!memberCard.id || memberCard.id != cardholder.id) {
              memberCard.cardType = 'secondary';
            }
          });
        } else if (typeof index !== 'undefined' && membership.membershipInfo.membershipCards[index]) {
          membership.membershipInfo.membershipCards.forEach((memberCard, cardIndex) => {
            if (cardIndex !== index) {
              memberCard.cardType = 'secondary';
            }
          });
        }
      }
    },

    isMembershipRenewal: function (membership) {
      return MembershipService.isRenewal(membership);
    },

    checkForSelectedCustomerMemberships: function (customerDuplicatesState) {
      const dupes = customerDuplicatesState.filter(
        (dupe) => dupe.match && dupe.dupesStatus === 'selected_existing_customer',
      );

      ctrl.loadingCustomerMemberships = true;

      Promise.all(
        dupes.map((dupe) => {
          return ApiService.customers.detail({
            customerId: dupe.match.id,
            includeAssociatedMemberships: true,
            includeMergeHistory: false,
          });
        }),
      )
        .then((response) => {
          const customerMemberships = response
            .map((res) => HelpersService.path(res, ['data', 'payload'], null))
            .filter((customer) => !!customer);
          ctrl.setCustomerMembershipsState(customerMemberships);
        })
        .finally(() => {
          ctrl.customerMembershipsState = ctrl.getCustomerMembershipsState();
          ctrl.loadingCustomerMemberships = false;
        });
    },

    clearCustomerMembershipState: function () {
      ctrl.loadingCustomerMemberships = false;
      ctrl.customerMembershipsState = [];
      CartService.memberships.clearCustomerMemberships();
    },

    setCustomerMembershipsState: function (customerMembershipsFromServer) {
      const customerMembershipsProcessed = customerMembershipsFromServer.map((customer) => {
        const memberships = customer.memberships || [];

        customer.memberships = _.chain(memberships)
          .filter({ auxiliaryMembership: false, lastVersion: true })
          .orderBy(['membershipExpirationDate'], ['desc'])
          .map((membership) => {
            membership.primaryCardholder = membership.cardholders.find(
              (cardholder) => cardholder.cardType === 'primary',
            );
            membership.membershipExpirationDateDisplay = $filter('date')(
              CalendarService.parseDate(membership.membershipExpirationDate),
              HelpersService.dateFormats.shortDate,
            );
            return membership;
          })
          .value();

        return customer;
      });
      CartService.memberships.setCustomerMemberships(customerMembershipsProcessed);
    },

    getCustomerMembershipsState: function () {
      return CartService.memberships.getCustomerMemberships() || [];
    },

    checkForDupes: function (membership: TODO) {
      if (membership !== undefined) {
        return ApiService.dedupe
          .list(membership)
          .then((response) => {
            ctrl.setCustomerDuplicatesState(response.data.payload);
            CartService.memberships.setMembershipCartData(ctrl.memberships[0]);
          })
          .catch(() => {
            // noop
          });
      }

      return $q.resolve();
    },

    findPossibleDuplicatesByIndex: function (index) {
      const customerDuplicates = ctrl.customerDuplicatesState[index];
      return customerDuplicates ? customerDuplicates.possibleDuplicates : null;
    },

    /**
     * It may be the case that we can't find the customer duplicates state
     * like when the index is `undefined` while adding a new cardholder (@link https://acmeticketing.atlassian.net/browse/APP-628)
     * so we default to an empty object to be able to attach properties to it (e.g. `showCustomers`, `match`).
     */
    findCustomerDuplicatesStateByIndex: function (index) {
      return ctrl.customerDuplicatesState[index] || {};
    },

    findContactMatchByIndex: function (index) {
      const customerDuplicates = ctrl.customerDuplicatesState[index];
      return customerDuplicates && ctrl.showCustomers ? customerDuplicates.match : null;
    },

    checkCardholderMatchesDupesStatus: function (index, status) {
      const entity = ctrl.customerDuplicatesState[index];

      if (!entity) {
        return false;
      }

      return entity.dupesStatus === status;
    },

    /**
     * This function can be used to change a cardholder entity in an immutable way
     */
    updateCustomerDuplicate: function (
      cardholderIndex: number,
      newCardholderData: {
        status: 'unknown' | 'potential_match' | 'selected_existing_customer' | 'none_match';
        originalCardholder: MembershipCardholder;
        cardholder: MembershipCardholder;
      },
    ) {
      ctrl.customerDuplicatesState = ctrl.customerDuplicatesState.map((customerDuplicate, index) => {
        if (cardholderIndex === index) {
          const match = newCardholderData.status === 'selected_existing_customer' ? newCardholderData.cardholder : null;
          const hasOriginalCardholder = !!customerDuplicate.originalCardholder;

          return Object.assign({}, customerDuplicate, {
            dupesStatus: newCardholderData.status,
            match: match,
            originalCardholder: hasOriginalCardholder
              ? customerDuplicate.originalCardholder
              : newCardholderData.originalCardholder,
          });
        }

        return customerDuplicate;
      });

      CartService.memberships.setCustomerDuplicates(ctrl.customerDuplicatesState);
    },

    getCustomerDuplicatesState: function () {
      return CartService.memberships.getCustomerDuplicates() || [];
    },

    setCustomerDuplicatesState: function (customerDuplicatesFromServer) {
      const customerDuplicatesFromStorage = CartService.memberships.getCustomerDuplicatesFromStorage() || [];
      const cardholders = ctrl.memberships[0].membershipInfo.membershipCards ?? [];

      const customerDuplicates = customerDuplicatesFromServer.map((customerDuplicate, index) => {
        const customerDuplicateFromStorage = customerDuplicatesFromStorage[index];
        const dupesStatusFromStorage = HelpersService.path(customerDuplicateFromStorage, ['dupesStatus'], 'unknown');
        const selected =
          dupesStatusFromStorage === 'selected_existing_customer' ? customerDuplicateFromStorage : customerDuplicate;
        const originalCardholder =
          dupesStatusFromStorage === 'selected_existing_customer' ? selected.originalCardholder : cardholders[index];

        return {
          customer: selected.customer,
          possibleDuplicates: selected.possibleDuplicates,
          dupesStatus: CartService.memberships.getDupesStatus(selected),
          match: selected.match,
          originalCardholder: originalCardholder,
        };
      });

      CartService.memberships.setCustomerDuplicates(customerDuplicates);
      ctrl.customerDuplicatesState = customerDuplicates;
    },

    normalizeCardholderFromServer: function (cardholder, originalCardholder) {
      let address = Array.isArray(cardholder.address) ? cardholder.address[0] : cardholder.address;
      address = address || {
        city: undefined,
        country: undefined,
        state: undefined,
        streetAddress1: undefined,
        streetAddress2: undefined,
        zipCode: undefined,
      };

      return {
        customerId: cardholder.id || originalCardholder.id, // ID coming from possibleDuplicates is refering to customerId
        constituentImportId: cardholder.externalCustomerImportId,
        cardType: cardholder.cardType || originalCardholder.cardType,
        prefix: cardholder.prefix,
        name: cardholder.fullName,
        firstName: cardholder.firstName,
        middleName: cardholder.middleName,
        lastName: cardholder.lastName,
        email: cardholder.email,
        phoneNumber: cardholder.phoneNumber,
        streetAddress1: address.streetAddress1,
        streetAddress2: address.streetAddress2,
        city: address.city,
        state: address.state,
        zipCode: address.zipCode,
        country: address.country,
        deceased: cardholder.deceased || originalCardholder.deceased,
        primaryCard: cardholder.primaryCard,
        startDate: cardholder.startDate,
        expirationDate: cardholder.expirationDate,
        excludeCardOnMemberCreation:
          cardholder.excludeCardOnMemberCreation || originalCardholder.excludeCardOnMemberCreation,
        ignoreUpdates: cardholder.ignoreUpdates || originalCardholder.ignoreUpdates,
        address: address,
        type: 'contact',
      };
    },

    showReviewPotentialMatches: function (props: { cardholder: TODO; index: number }) {
      const index = props.index;
      const cardholder = props.cardholder;
      const cardholderData = { index: index, cardholder: cardholder };
      const customerDuplicatesData = ctrl.findCustomerDuplicatesStateByIndex(index);

      const potentialMatchesModal = $uibModal.open<TODO>({
        size: 'lg',
        backdrop: 'static',
        controller: 'DedupeModalController',
        templateUrl: 'common/views/modals/dedupe/dedupe.tpl.html',
        resolve: {
          CardholderData: () => {
            return { index: cardholderData.index, cardholder: cardholderData.cardholder };
          },
          CustomerDuplicatesData: () => {
            return customerDuplicatesData;
          },
          ShowCustomers: () => {
            return ctrl.showCustomers;
          },
        },
      });

      // * @param {*} data Object with status and cardholder selected
      potentialMatchesModal.result.then((data) => {
        const originalCardholder = ctrl.findCustomerDuplicatesStateByIndex(data.index).originalCardholder;
        const newCardholder = data.noneMatch && originalCardholder ? originalCardholder : data.cardholder;
        const normalizedCardholder = ctrl.normalizeCardholderFromServer(newCardholder, cardholderData.cardholder);

        ctrl.clearCustomerMembershipState();

        ctrl.updateCustomerDuplicate(data.index, {
          status: data.status,
          cardholder: data.cardholder,
          originalCardholder: originalCardholder || Object.assign({}, cardholderData.cardholder),
        });

        Object.assign(cardholder, normalizedCardholder);
        ctrl.cardUpdated();
      });
    },

    showCardModal: function (props: {
      cardholder: TODO;
      membership: TODO;
      mode: 'create' | 'edit' | 'edit.dedup';
      index: number;
    }) {
      let cardholder = props.cardholder;
      const membership = props.membership;
      const mode = props.mode;
      const index = props.index;
      const edit = mode.startsWith('edit');

      const membershipCards = membership.membershipInfo.membershipCards || [];
      const isNewMembershipNoCards =
        Array.isArray(membershipCards) &&
        !membershipCards.length &&
        CartService.memberships.isNewMembership(membership.itemType);
      const customerDuplicatesData = ctrl.findCustomerDuplicatesStateByIndex(index);

      const orderContact = ctrl.cartService.getOrderContact();

      if (customerDuplicatesData || !ctrl.cartService.memberships.hasNewMembership()) {
        customerDuplicatesData.showCustomers = ctrl.showCustomers;
      }

      if (edit && !ctrl.cartService.memberships.hasNewMembership()) {
        customerDuplicatesData.match = Object.assign({}, orderContact, {
          id: orderContact?.customerId,
          fullName: ctrl.cartService.getOrderContactFullName(),
        });
      }

      ctrl.getAddresses(membership);

      const editModal = $uibModal.open<TODO>({
        size: 'lg',
        backdrop: 'static',
        controller: 'VcardModalController',
        templateUrl: 'common/views/modals/vcard/vcard.tpl.html',
        resolve: {
          mode: () => {
            return mode;
          },
          isSearch: () => {
            return edit ? false : true;
          },
          modalTitle: () => {
            return edit ? 'Edit cardholder' : isNewMembershipNoCards ? 'Add Primary Cardholder' : 'Add Cardholder';
          },
          saveText: () => {
            return edit ? 'Save' : 'Add';
          },
          CardData: () => {
            let primaryCardholder;
            let cardData;

            if (!edit && membership) {
              primaryCardholder = ctrl.getPrimaryCardholder(membership);
              cardData = {
                cardType: primaryCardholder ? 'secondary' : 'primary',
                address: {},
              };
            } else {
              cardData = cardholder;
            }

            return angular.copy(cardData);
          },
          AddressId: () => {
            return membership.membershipInfo.membershipId;
          },
          CustomerDuplicatesData: () => {
            return customerDuplicatesData;
          },
          ModalData: () => {
            return {
              isAutorenewMembership: ctrl.cartService.memberships.isAutorenewMembership(
                ctrl.membershipLevels,
                membership,
              ),
              membershipErrors: ctrl.membershipErrors,
            };
          },
        },
      });

      editModal.result
        .then((data) => {
          ctrl.clearCustomerMembershipState();
          if (data && data.contact) {
            if (!edit) {
              if (!(membership.membershipInfo.membershipCards instanceof Array)) {
                membership.membershipInfo.membershipCards = [];
              }
              membership.membershipInfo.membershipCards.push(data.contact);
              ctrl.updateMembershipCardTypes(
                data.contact,
                membership,
                membership.membershipInfo.membershipCards.length - 1,
              );

              if (membership.membershipInfo.membershipCards.length > 0) {
                /**
                 * When adding the 1st cardholder to the cart's membership their "Primary card holder is required"
                 * message is still shown after we have added a cardholder for a few seconds.
                 */
                membership.messages = [];
              }
            } else {
              cardholder = angular.extend(cardholder, data.contact);
              ctrl.updateMembershipCardTypes(cardholder, membership, index);
            }

            if (data.contact.prevName) {
              membership.membershipInfo.membershipCards.forEach((item) => {
                const formattedAddress = addressService.getFormattedAddress(item.address);

                if (data.contact.prevName === formattedAddress.name) {
                  item.address = Object.assign({}, item.address, data.contact.address);
                  delete item.address.prevName;
                  delete item.address.name;

                  Object.assign(item, item.address, data.contact.address);
                }
              });
            }

            if (mode !== 'edit.dedup') {
              // Check for dupes, the call will handle the error checking
              if (!ctrl.cartService.memberships.hasNewMembership()) {
                ctrl.cartService.setOrderContact(membership);
              }

              ctrl.checkForDupes(membership.membershipInfo.membershipCards).then(() => {
                ctrl.cardUpdated();
              });
            } else {
              ctrl.cardUpdated();
            }
          } else {
            ctrl.cardUpdated();
          }
        })
        .catch(() => {
          // Do nothing
        });
    },

    showRemoveCardModal: function (props: { cardholder: TODO }) {
      const cardholder = props.cardholder;

      const removeModal = $uibModal.open<TODO>({
        size: 'md',
        controller: 'ConfirmModalController',
        templateUrl: 'common/views/modals/confirm/confirm.tpl.html',
        resolve: {
          modalTitle: () => 'Are you sure?',
          okText: () => 'Remove',
          modalMessage: () => `Do you want to remove ${cardholder.name}?`,
        },
      });

      removeModal.result
        .then(() => {
          cardholder.excludeCardOnMemberCreation = true;
          ctrl.cardUpdated();
        })
        .catch(() => {
          // Do nothing
        });
    },

    showAutoRenewTermsAndConditionsModal: function () {
      const companyEmail = ThemesHelperService.getEmailVariable('b2c-support-email');
      const phoneNumber = ctrl.tenant.phoneNumber || '';
      const autorenewTermsAndConditionsModal = $uibModal.open({
        size: 'md',
        controller: 'ConfirmModalController',
        templateUrl: 'common/views/modals/confirm/confirm.tpl.html',
        resolve: {
          modalTitle: () => {
            return 'Auto Renew Terms and Conditions';
          },
          okText: () => {
            return 'OK';
          },
          modalMessage: () => {
            let secondLine =
              '<p>If you wish to cancel your Auto Renew membership, you must contact the venue at least thirty (30) days prior to your membership renewal date.</p>';
            if (Object.keys(ctrl.tenant).length > 0 && (phoneNumber || companyEmail)) {
              secondLine =
                '<p>If you wish to cancel your Auto Renew membership, you must contact the venue' +
                (phoneNumber || companyEmail ? ' at' : '') +
                (phoneNumber ? ' ' + phoneNumber : '') +
                (phoneNumber && companyEmail ? ' or' : '') +
                (companyEmail ? ' <a href="mailto:' + companyEmail + '">' + companyEmail + '</a>' : '') +
                ' at least thirty (30) days prior to your membership renewal date.</p>';
            }

            return [
              '<p>If you choose an Auto Renew membership, you agree that we will keep your payment information on file. Your card will be charged up to fourteen (14) days prior to your membership renewal date.</p>',
              secondLine,
              '<p>If you have any concerns, issues, or questions regarding your Auto Renew membership, please contact the venue to help resolve.</p>',
            ].join('');
          },
        },
      });

      autorenewTermsAndConditionsModal.result.catch(() => {
        // noop
      });
    },

    cardUpdated: function () {
      ctrl.saveCart();
    },

    restoreCardholder: function (props: { cardholder: TODO }) {
      const cardholder = props.cardholder;
      cardholder.excludeCardOnMemberCreation = false;
      ctrl.cardUpdated();
    },

    updateTotal: function () {
      ctrl.total = ctrl.cartService.getTotal();
    },

    getTicketAmount: function (event) {
      let result = 0;
      angular.forEach(event.tickets, function (ticket) {
        result += HelpersService.currencyFloatToInteger(ticket.amount, 2); //or should it be unitPrice?
      });

      return result;
    },

    checkCartValid: function (submitting = false) {
      let validatorsMap;
      let isValid = true;

      ctrl.errors = {};

      ctrl.memberships.forEach((membership) => {
        const membershipCards = membership.membershipInfo.membershipCards || [];
        const isNewMembershipNoCards =
          Array.isArray(membershipCards) &&
          !membershipCards.length &&
          CartService.memberships.isNewMembership(membership.itemType);
        membership.errors = [];
        membership.messages = [];
        validatorsMap = {
          numCards: [
            {
              field: 'membership-numcards-max',
              less: {
                message: ctrl.membershipErrors.tooManyCards.message.replace(
                  '%s',
                  membership.level ? membership.level.rules.numberOfCardHolders : 0,
                ),
                test: function () {
                  let r: TODO[] = [];
                  if (membershipCards instanceof Array) {
                    r = membershipCards;
                  }
                  return {
                    greater: membership.level
                      ? r.filter((card) => {
                          return !card.excludeCardOnMemberCreation;
                        }).length
                      : 0,
                    less: membership.level ? membership.level.rules.numberOfCardHolders : 0,
                    equalTo: true,
                  };
                },
              },
            },
          ],
          primaryCard: [
            {
              field: 'membership-primary-card',
              greater: {
                message: ctrl.membershipErrors.missingPrimaryCard.message,
                test: function () {
                  let numCards = 0;
                  if (membershipCards instanceof Array) {
                    if (isNewMembershipNoCards) {
                      numCards = 1;
                    } else {
                      numCards = membershipCards.filter((card) => {
                        return card.cardType === 'primary' && !card.excludeCardOnMemberCreation;
                      }).length;
                    }
                  }
                  return {
                    greater: numCards,
                    less: 1,
                    equalTo: true,
                  };
                },
              },
            },
            {
              field: 'membership-primary-card-address',
              equal: {
                message: ctrl.membershipErrors.missingPrimaryCardAddress.message,
                test: function () {
                  const cardholder = ctrl.getPrimaryCardholder(membership);

                  if (ctrl.isCardType(cardholder, 'primary')) {
                    const isValidAddress = addressService.validateAddress(cardholder.address);
                    return [isValidAddress, true];
                  }

                  return [true, true];
                },
              },
            },
            {
              field: 'membership-primary-card-email',
              equal: {
                message: ctrl.membershipErrors.missingPrimaryCardEmailForAutorenew.message,
                test: function () {
                  const cardholder = ctrl.getPrimaryCardholder(membership);

                  if (
                    ctrl.isCardType(cardholder, 'primary') &&
                    ctrl.cartService.memberships.isAutorenewMembership(ctrl.membershipLevels, membership)
                  ) {
                    const isValidEmail = ValidateService.validators.email(cardholder.email);
                    return [isValidEmail, true];
                  }

                  return [true, true];
                },
              },
            },
          ],
        };

        const validators = membership.level
          ? validatorsMap.numCards.concat(validatorsMap.primaryCard)
          : validatorsMap.primaryCard;

        ValidateService.validate(validators);
        membership.errors = ValidateService.errors;
        if (membership.errors.length) {
          ctrl.errors.membershipErrors = true;
          isValid = false;
        }
        if (isNewMembershipNoCards) {
          membership.messages = ['Primary cardholder is required.'];
        }

        const paymentValidatorsMap = {
          autorenew: [
            {
              field: 'credit-card-payment-required-for-autorenew',
              equal: {
                message: ctrl.paymentErrors.creditCardPaymentRequiredForAutorenew.message,
                test: function () {
                  if (ctrl.cartService.memberships.isAutorenewMembership(ctrl.membershipLevels, membership)) {
                    return [ctrl.payment.type, 'CreditCard'];
                  }

                  return [true, true];
                },
              },
            },
          ],
        };
        let paymentValidators: TODO[] = [];

        if (ctrl.cartService.memberships.isAutorenewMembership(ctrl.membershipLevels, membership)) {
          paymentValidators = paymentValidators.concat(paymentValidatorsMap.autorenew);
        }

        ValidateService.validate(paymentValidators);
        const paymentErrors = ValidateService.errors;

        if (paymentErrors.length) {
          ctrl.errors.paymentErrors = paymentErrors;
          isValid = false;
        }
      });

      if (submitting) {
        ctrl.events.forEach((event) => {
          if (ctrl.cartService.events.getEventTicketCount(event.eventId) <= 0) {
            event.hasTicketError = true;
            ctrl.errors.ticketErrors = true;
            isValid = false;
          }

          if (event.reservationError) {
            ctrl.errors.reservationErrors = true;
            isValid = false;
          }

          if (!ctrl.cartService.events.validateMemberRestriction(event.eventId)) {
            event.restrictedEventError = true;
            ctrl.errors.membershipErrors = true;
            isValid = false;
          } else {
            event.restrictedEventError = false;
          }
        });

        if (cartFormsService.hasUnrespondedRequiredForms(ctrl.forms, ctrl.memberships)) {
          ctrl.errors.formErrors = true;
          isValid = false;
        } else {
          ctrl.errors.formErrors = false;
        }
      } else {
        ctrl.events.forEach((event) => {
          event.hasTicketError = false;
          event.restrictedEventError = false;
        });
      }

      return isValid;
    },

    hasSalesRules: function () {
      let result = false;
      if (ctrl.events instanceof Array && ctrl.events.length) {
        for (let i = 0, ii = ctrl.events.length; i < ii; i++) {
          if (ctrl.cartService.events.hasSalesRules(ctrl.events[i])) {
            result = true;
            break;
          }
        }
      }
      return result;
    },

    saveCart: function () {
      ctrl.startSubmitting();
      ctrl.cartService
        .updateCart()
        .then((response) => {
          ctrl.stopSubmitting();
          ctrl.refresh();
        })
        .catch((response) => {
          ctrl.stopSubmitting();
          ctrl.notice.showErrorMessages([{ message: response.data.error }]);
        });
    },

    launchOrganizationOrder: function (e, data) {
      //copy organization, events and quantities to the old organization checkout flow
      //cancel the cart
      const orgOrder = ctrl.cartService.events.getOrganizationOrder();

      OrderService.init();
      OrderService.clear();
      OrderService.store({
        cart: {
          events: orgOrder.events,
        },
      });

      ctrl.cartService.cancelCart();

      $state.go('application.orders.checkout', { accountId: orgOrder.organizationId });
    },

    isRefund: function () {
      return CartService.getMembershipItem() && ctrl.total < 0;
    },

    getCartStep: function (section: 'forms' | 'payment' | 'orderOptions'): number {
      const hasForms = ctrl.forms.length > 0;
      switch (section) {
        case 'forms': return 2;
        case 'payment': return hasForms ? 3 : 2;
        case 'orderOptions': return hasForms ? 4 : 3;
      }
    },

    checkForRefundMembership: function () {
      const q = $q.defer();
      let membershipType = null;

      if (ctrl.isRefund()) {
        const memberships = CartService.memberships.getUpgradeDowngradeMembership();
        membershipType = MembershipService.getMembershipTypeLabelByName(memberships[0].itemType);

        const modal = $uibModal.open<TODO>({
          templateUrl: 'views/application/views/cart/confirmRefund.tpl.html',
          controller: 'OrdersRefundConfirmModalController',
          resolve: {
            currentRefund: () => {
              return { type: membershipType };
            },
          },
        });

        return modal.result;
      } else {
        q.resolve();
      }

      return q.promise;
    },

    clearLoading: function () {
      ctrl.stopSubmitting();
      ctrl.isPaymentProcessing = false;
    },

    // TODO: Move all checkout process to CartService
    processPayment: function () {
      ctrl.notice.hideSuccessMessages();
      ctrl.notice.hideErrorMessages();

      if (ctrl.checkCartValid(true)) {
        ctrl.startSubmitting();
        ctrl.errors = {};

        if (!ctrl.isPaymentProcessing) {
          ctrl.isPaymentProcessing = true;
          ctrl.validateEmail = parseInt(ctrl.emailOption as TODO, 10) === 0 ? false : true;
          $scope.$broadcast('Payment::Process', { validateEmail: ctrl.validateEmail });
          ctrl.processPaymentErrors();
        }
      } else {
        ctrl.notice.showErrorMessages([{ message: 'Please correct the errors below.' }]);
      }
    },

    processPaymentErrors: function () {
      const paymentErrors: TODO = ValidateService.getErrorHash();

      ctrl.hasEmailError = false;

      // TODO: Remove angular.forEach
      angular.forEach(paymentErrors, function (item, index: any) {
        if (index === 'payment-email') {
          ctrl.hasEmailError = true;
        }
      });
    },

    shouldUseCORSCheckout() {
      const requiresCardData = ctrl.total > 0 || (ctrl.autorenewInCart.enabled && !ctrl.isRefund());
      return CheckoutProcessService.shouldUseCORSCheckout({ requiresCardData });
    },

    complete: function (payment) {
      let organizationContact;

      payment = payment || {};

      ctrl.setEmailOption();

      if (ctrl.accountId) {
        if (ctrl.selectedAccountContact) {
          organizationContact = {
            contactId: ctrl.selectedAccountContact.id,
            firstName: ctrl.selectedAccountContact.firstName || '',
            lLastName: ctrl.selectedAccountContact.lastName || '',
            email: ctrl.selectedAccountContact.email || '',
            phoneNumber: ctrl.selectedAccountContact.phoneNumber || '',
          };
        }
      }

      const customerId = HelpersService.path(ctrl.memberships, [
        0,
        'membershipInfo',
        'membershipCards',
        0,
        'customerId',
      ]);

      const order = {
        notes: ctrl.notes,
        shoppingCartId: CartService.getModel().id,
        billingContact: {
          firstName: payment.contactFirstName,
          lastName: payment.contactLastName,
          email: payment.contactEmail,
          phoneNumber: payment.phoneNumber,
          address: payment.address || null,
        },
        accountId: ctrl.accountId || null,
        customerId: customerId,
        saleChannel: ctrl.accountId ? 'reseller' : 'insideSalesIndividual',
        organizationContact: organizationContact || null,
        acmeToken: payment.acmeToken || null,
        manualEntryCardNumber: payment.manualEntryCardNumber || null,
        expDate: payment.expDate || null,
        ccLastFourDigits: payment.ccLastFourDigits || null,
        cvc: payment.cvc || null,
        chargeAmount: payment.chargeAmount || null,
        paymentId: payment.paymentId || null,
        ticketDelivery: ctrl.ticketDelivery,
        paymentMethod: payment.type,
        invoiceAfterEvent: ctrl.invoiceAfterEvent,
        emailLanguage: ctrl.emailLanguage,
        reservationId: ctrl.reservation && ctrl.reservation.id,
        noEmail: ctrl.noEmail,
        sendEmailToAll: ctrl.sendEmailToAll,
        paymentProcessorToken: null,
        creditCardBrand: null,
      };

      // TODO: stuff below
      // if (ctrl.hasCustomerId()) {
      //   order.customerId = ctrl.model.customerId;
      // }

      // if (ctrl.order.orderRequest) {
      //   order.orderRequestId = ctrl.order.orderRequest.id ? ctrl.order.orderRequest.id : '';
      // }

      /**
       * we are passing empty CC fields in case the order is $0.00 or less
       * but we have to be sure theres no autorenew membership in it
       * if thats the case we have to pass CC data
       */
      const doesNotRequireCardData = !payment.hasSubscription && ctrl.total <= 0 && !ctrl.autorenewInCart.enabled;

      if (doesNotRequireCardData) {
        order.acmeToken = null;
        order.paymentProcessorToken = null;
        order.ccLastFourDigits = null;
        order.creditCardBrand = null;
        order.cvc = null;
      }

      /**
       * This is order duplication prevention
       * We create the checkout UUID and tack it onto the checkout request
       * Only rewrite the requestUUID when there are no errors and a checkout has taken place
       * This will always be refreshed when the page is refreshed, but, in the context of an order
       * it should only be overwritten if it has been explicitly set to `false`
       */
      if (!ctrl.requestUUID) {
        ctrl.requestUUID = uuid2.newuuid();
      }

      if (ctrl.shouldUseCORSCheckout()) {
        const data: CheckoutData = CheckoutProcessService.processCheckoutData(
          {
            ...order,
            requestUUID: ctrl.requestUUID,
          },
          { withCreditCardInfo: false },
        );

        CheckoutProcessService.handleACMEPaymentSession(
          ctrl.processCORSCheckoutPaymentData(
            {
              ...data,
              chargeAmount: String(ctrl.total),
            },
            order.billingContact.address,
          ),
        )
          .then((response) => ctrl.completeSuccess(response))
          .catch(async (response) => {
            if (isACMECORSCheckoutError(response)) {
              switch (response.type) {
                case 'sdk.render_failed': {
                  ctrl.clearLoading();

                  ctrl.completeError({
                    status: 0,
                    data: { code: 0, errorCode: 0, error: response.params.message },
                  });
                  break;
                }

                case 'sdk.cancel_flow': {
                  ctrl.clearLoading();
                  break;
                }

                case 'sdk.billing_address.request_change': {
                  ctrl.clearLoading();

                  await ctrl.cartService.waitFor('idle');
                  document.querySelector(`[data-testid="billing-address-anchor"]`)?.scrollIntoView();
                  break;
                }

                case 'api.error': {
                  ctrl.completeError(CheckoutProcessService.mapToPaymentProcessError(response));
                  break;
                }

                default: {
                  console.warn(`unhandled`, response);

                  ctrl.clearLoading();
                  break;
                }
              }
            } else {
              ctrl.completeError(response);
            }
          });
      } else {
        const data: CheckoutData = CheckoutProcessService.processCheckoutData(
          {
            ...order,
            requestUUID: ctrl.requestUUID,
          },
          { withCreditCardInfo: true },
        );

        ApiService.cart.checkout
          .create(data)
          .then((response) => ctrl.completeSuccess(response.data.payload))
          .catch((response) => ctrl.completeError(response));
      }
    },

    processCORSCheckoutPaymentData: function (
      data: CheckoutData & { chargeAmount: string },
      address: TODO,
    ): SecureCheckoutProps {
      const countryData = LocationService.findCountry({ country: data.billingCountry });
      const stateData = LocationService.findState({ state: data.billingState });

      const cssVarsData = CheckoutProcessService.getCORSCheckoutCSSVariables();

      return {
        values: data,
        options: {
          formattedBillingAddress: addressService.formatAddress({
            streetAddress1: data.billingAddress1,
            streetAddress2: data.billingAddress2,
            country: countryData ? countryData.country.name : data.billingCountry,
            zipCode: data.billingZipCode,
            city: data.billingCity,
            state: stateData ? stateData.name : data.billingState,
          }),
          modal: {
            title: 'Payment',
            submit: 'Complete Order',
            close: 'Close',
          },
          authorizePayment: {
            paymentData: {
              externalId: data.shoppingCartId,
              chargeAmount: data.chargeAmount,
              firstName: data.billingFirstName || '',
              lastName: data.billingLastName || '',
              creditCardVerificationData: {
                address1: data.billingAddress1,
                address2: data.billingAddress2,
                country: countryData ? String(countryData.country.numericCode) : address.country,
                zipCode: data.billingZipCode,
                city: data.billingCity,
                state: stateData ? stateData.abbreviation : address.state,
              },
            },
            saleChannel: ctrl.accountId ? 'reseller' : 'insideSalesIndividual',
          },
          capturePayment: {
            loaderHtml: CheckoutProcessService.getCheckoutLoadingHtml(),
          },
          autorenew: {
            enabled: ctrl.autorenewInCart.enabled,
            html: ThemesHelperService.getTextVariable('checkout-process-page-autorenew-message'),
            url: `${ctrl.termsURL}#membership-auto-renewal`,
          },
          terms: {
            html: ThemesHelperService.getHTMLVariable('checkout-process-page-terms'),
            url: ctrl.termsURL,
          },
          creditCardSettings: {
            supportedCardsText: ThemesHelperService.getTextVariable('checkout-supported-cards-text'),
            showVisaLogo: ThemesHelperService.getTextVariable('checkout-show-visa-logo'),
            showMcLogo: ThemesHelperService.getTextVariable('checkout-show-mc-logo'),
            showDiscoverLogo: ThemesHelperService.getTextVariable('checkout-show-discover-logo'),
            showAmexLogo: ThemesHelperService.getTextVariable('checkout-show-amex-logo'),
          },
          variables: cssVarsData,
        },
      };
    },

    renderButtonLabel: function () {
      let buttonLabel = 'Place Order';
      if (ctrl.shouldUseCORSCheckout()) {
        buttonLabel = 'Take Payment & Place Order';

        if (!ctrl.total && ctrl.autorenewInCart.enabled) {
          buttonLabel = 'Collect CC & Place Order';
        }
      }

      return buttonLabel;
    },

    getDuplicateOrder: function () {
      const uuid = ctrl.requestUUID ? ctrl.requestUUID : '';

      ApiService.system
        .uuidObjectRegistry({ uuid })
        .then((response) => {
          // Navigate to duplicate order
          $state.go('application.orders.detail.summary', { orderId: response.data.payload.orderId });
        })
        .catch((response) => {
          ctrl.completeError(response);
        });
    },

    disallowCheckout: function () {
      return (
        !ctrl.model.items.length ||
        ctrl.isSubmitted ||
        ctrl.errors.membershipErrors ||
        ctrl.errors.ticketErrors ||
        ctrl.errors.reservationErrors ||
        ctrl.errors.paymentErrors ||
        CartService.getSnapshot().status === 'loading'
      );
    },

    cancel: function () {
      const cancelModal = $uibModal.open<TODO>({
        size: 'md',
        controller: 'ConfirmModalController',
        templateUrl: 'common/views/modals/confirm/confirm.tpl.html',
        resolve: {
          modalTitle: () => 'Are you sure?',
          okText: () => 'Cancel Order',
          modalMessage: () => 'Do you want to cancel this order?',
        },
      });

      cancelModal.result
        .then(() => {
          $scope.$emit('Cart::Close');
          ctrl.cartService.cancelCart().then(ctrl.cancelSuccess).catch(ctrl.cancelError);
        })
        .catch(() => {
          // Do nothing
        });
    },

    canSendMemberCardEmail: function () {
      const selectedOffering =
        ctrl.memberships.length && ctrl.memberships[0].level && ctrl.memberships[0].level.selectedOffering;

      if (selectedOffering) {
        return MembershipService.canSendMemberCardsForAction(
          selectedOffering,
          MembershipService.getEmailActionFromPurchaseType(ctrl.memberships[0].itemType),
        );
      }

      return false;
    },

    showCoupons: function () {
      return (
        (ctrl.memberships.length > 0 || ctrl.events.length > 0) &&
        !CartService.getItemByType(MembershipService.purchaseTypes.downgrade.name)
      );
    },

    onPaymentComplete: function (e, data) {
      console.log('Cart::onPaymentComplete', data);

      CheckoutProcessService.setPaymentData(data);

      ctrl
        .checkForRefundMembership()
        .then(() => {
          ctrl.complete(data);
        })
        .catch(() => {
          ctrl.clearLoading();
        });
    },

    onPaymentError: function (e, data) {
      ctrl.clearLoading();

      ctrl.notice.showErrorMessages([{ message: data }]);

      $scope.noticeTimer = $timeout(() => {
        ctrl.notice.hideSuccessMessages();
      }, 3000);
    },

    onOrderItemUpdated: function (e, data) {
      ctrl.refresh();
    },

    onOrderItemRemove: function (e, data) {
      ctrl.refresh();
    },

    onOrderItemRemoveError: function (e, data) {
      if (data) {
        ctrl.notice.showErrorMessages([{ message: data.error }]);
      }
    },

    onItemCountUpdated: function (n, o) {
      ctrl.notice.hideSuccessMessages();
      ctrl.notice.hideErrorMessages();

      if (!ctrl.model || n !== o) {
        ctrl.refresh();
      }
    },

    onCartServiceInitted: function (n, o) {
      if (n !== o) {
        ctrl.refresh();
      }
    },

    onCartOrganizationUpdate: function (n, o) {
      if (n && n.id) {
        ctrl.organization = ctrl.cartService.getOrganization();
      }
    },

    onCheckedInvoiceAfterEvent: function (n, o) {
      if (n) {
        ctrl.emailOption = 0;
        //since we're auto selecting do not send email, we should also set ticketDelivery by willcall and not email.
        ctrl.setEmailOption();
      }
    },

    onEmailOptionUpdate: function (n, o) {
      if (n !== undefined && n === '0') {
        ctrl.setEmailOption();
      }
    },

    onMembershipsUpdate: function (newValue, oldValue) {
      if (newValue) {
        ctrl.vm.sections.membershipCardsEmail.show = ctrl.canSendMemberCardEmail();
        ctrl.vm.primaryCardholder = ctrl.getPrimaryCardholder(ctrl.memberships[0]);
      }
    },

    onPaymentShowCardModal: function (e, data) {
      const cardholder = ctrl.memberships[0].membershipInfo.membershipCards[data.index];
      console.log(e, data);
      ctrl.showCardModal({ cardholder: cardholder, membership: ctrl.memberships[0], mode: 'edit', index: data.index });
    },

    onPaymentMethodUpdate: function (e: TODO, data: { paymentMethod: string }) {
      ctrl.payment.type = data.paymentMethod;
      ctrl.checkCartValid();
    },

    /**
     * We have to save the shopping cart when `memberships[n].membershipInfo.isAutorenew` has changed because
     * the checkout uses `shoppingCartId` and the checkbox doesn't trigger an update automatically.
     */
    onAutorenewChanged: function () {
      ctrl.cardUpdated();
      ctrl.checkCartValid();
    },
  };

  $scope.cart = ctrl;
  $scope.cart.init();
}

export const CartControllerModule = angular
  .module('acme.view.application.cart.controllers', [
    uiRouter,
    'ui.bootstrap',
    'angularUUID2',
    CartServiceModule,
    'acme.common.service.auth',
    'acme.common.service.api',
    'acme.common.service.validate',
    'acme.common.service.helpers',
    AddressServiceModule,
    'acme.common.service.membership',
    'acme.common.service.themesHelper',
    'acme.common.service.order',
    'acme.common.factory.notice',
    'acme.common.factory.gridState',
    FeatureServiceModule,
    'acme.common.service.permissions',
    VCardModalControllerModule,
    'acme.view.application.modals.dedupe.controllers',
    'acme.view.application.modals.confirm.controllers',
    'acme.view.application.orders.refund.confirmModal.controllers',
    CartOrderConfirmationEmailComponentModule,
    CheckoutProcessServiceModule,
    LocationServiceModule,
    CartFormsServiceModule,
  ])
  .controller('CartController', CartController).name;
